import { render } from "./registration.vue?vue&type=template&id=22a80ad1"
import script from "./registration.js?vue&type=script&lang=js"
export * from "./registration.js?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=22a80ad1&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__